
import { Header } from "@/components/Header";
import Footer from "@/components/Footer";
import { ContactForm } from "@/components/ContactForm";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Mail, Phone } from "lucide-react";

const CustomerSupport = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-background/80">
      <Header />
      <main className="pt-24 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-primary via-primary/80 to-primary/60 bg-clip-text text-transparent animate-fade-in">
              Customer Support
            </h1>
            <p className="text-muted-foreground text-lg">
              We're here to help! Find answers to common questions or reach out to our support team.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <div className="p-6 bg-card rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border border-border hover:border-primary/20">
              <Phone className="w-12 h-12 mx-auto mb-4 text-primary" />
              <h3 className="text-xl font-semibold mb-2 text-card-foreground">Phone Support</h3>
              <p className="text-muted-foreground mb-4">Available Mon-Fri, 9am-5pm EST</p>
              <a href="tel:0221299230" className="text-primary hover:text-primary/80 transition-colors">
                02 2129 9230
              </a>
            </div>

            <div className="p-6 bg-card rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border border-border hover:border-primary/20">
              <Mail className="w-12 h-12 mx-auto mb-4 text-primary" />
              <h3 className="text-xl font-semibold mb-2 text-card-foreground">Email Support</h3>
              <p className="text-muted-foreground mb-4">24/7 Response Time</p>
              <a href="mailto:dubcityaisolutions@gmail.com" className="text-primary hover:text-primary/80 transition-colors">
                dubcityaisolutions@gmail.com
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            <div>
              <h2 className="text-2xl font-bold mb-6 text-card-foreground">Frequently Asked Questions</h2>
              <Accordion type="single" collapsible className="bg-card rounded-lg p-4 border border-border">
                <AccordionItem value="item-1">
                  <AccordionTrigger>How do I get started with your AI solutions?</AccordionTrigger>
                  <AccordionContent>
                    Getting started is easy! Simply choose your preferred AI agent, fill out our quick onboarding form, and our team will guide you through the setup process.
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="item-2">
                  <AccordionTrigger>What kind of support do you provide?</AccordionTrigger>
                  <AccordionContent>
                    We offer comprehensive support including 24/7 email assistance and phone support during business hours. Our team is always ready to help with technical issues, customization requests, and general inquiries.
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="item-3">
                  <AccordionTrigger>How secure is my data?</AccordionTrigger>
                  <AccordionContent>
                    We implement enterprise-grade security measures including encryption, secure data centers, and regular security audits. Your data is protected according to industry best practices and compliance standards.
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-6 text-card-foreground">Contact Us</h2>
              <ContactForm />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CustomerSupport;
